import { connect } from 'react-redux'

import {
  getProductList,
  setFilterValue,
} from 'reduxpath/ducks/Product/List'

import AddFilterSortProduct from 'utils/AddFilterSortProduct'

import CountryFilter from './units'

const mapStateToProps = state => ({
  countries: state.Reference.countries.rows,
  filter: state.ProductList.filter,
  sort: state.ProductList.sort,
})

const mapDispatchToProps = dispatch => ({
  onChangeCountry(field, filter, sort) {
    return (event) => {
      const dataFilter = {
        ...filter,
      }

      dataFilter[field] = event.target.value

      let qs = {
        sort: {
          isEligible: 'DESC',
          createdAt: 'DESC',
        },
        limit: 10,
        skip: 0,
        where: {
          isEligible: true,
        },
      }

      qs = AddFilterSortProduct(qs, dataFilter, sort)

      dispatch(setFilterValue(dataFilter))
      dispatch(getProductList(qs))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onChangeCountry: dispatchProps.onChangeCountry(
    'country',
    stateProps.filter,
    stateProps.sort,
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(CountryFilter)
